import CryptoJS from "crypto-js";
import config from "../config";

export function AkeadSignature256(data) {
  // const key = process.env.REACT_APP_CHIPER_KEY;
  const key = config().CHIPER_KEY;
  if (!key) throw new Error("CHIPER_KEY yok!");
  const hash = CryptoJS.HmacSHA256(data, key);
  return CryptoJS.enc.Base64.stringify(hash);
}

